<template>
  <a-card
    :bordered="false"
    :bodyStyle="{ padding: '16px 0', height: '100%' }"
    :style="{ height: '100%' }"
  >
    <div class="account-settings-info-view">
      <a-row :gutter="16" type="flex" justify="center">
        <a-col :md="24" :lg="16">
          <a-form :form="form">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上年漏损率(%)">
              <a-input
                placeholder="上年漏损率(%)"
                v-decorator="['lastLeakageRate',{rules: [{ pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="月漏损率(%)">
              <a-input
                placeholder="月漏损率(%)"
                v-decorator="['leakageRate',{rules: [{ pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="月总供水量(m³)">
              <a-input
                placeholder="月总供水量(m³)"
                v-decorator="['waterDelivery',{rules: [{ pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="月总耗电量(kw/h)">
              <a-input
                placeholder="月总耗电量(kw/h)"
                v-decorator="['waterPower',{rules: [{ pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="月总售水量(m³)">
              <a-input
                placeholder="月总售水量(m³)"
                v-decorator="['waterSell',{rules: [{ pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入数字' }]}]"
              />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="管网总长(km)">
              <a-input
                placeholder="管网总长(km)"
                v-decorator="['pipeLeght',{rules: [{ pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="管网本年新增(km)">
              <a-input
                placeholder="管网本年新增(km)"
                v-decorator="['pipeLeghtYear',{rules: [{ pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总用户数">
              <a-input
                placeholder="总用户数"
                v-decorator="['userSum',{rules: [{ pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="用户本年新增">
              <a-input
                placeholder="用户本年新增"
                v-decorator="['userSumYear',{rules: [{ pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="总阀门数">
              <a-input
                placeholder="总阀门数"
                v-decorator="['valveSum',{rules: [{ pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="阀门本年新增">
              <a-input
                placeholder="阀门本年新增"
                v-decorator="['valveSumYear',{rules: [{ pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入数字' }]}]"
              />
            </a-form-item>

            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水表抄见率(%)">
              <a-input
                placeholder="水表抄见率(%)"
                v-decorator="['seeRate',{rules: [{ pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="抄表完成率(%)">
              <a-input
                placeholder="抄表完成率(%)"
                v-decorator="['finishingRate',{rules: [{ pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="水费回收率(%)">
              <a-input
                placeholder="水费回收率(%)"
                v-decorator="['recoveryRate',{rules: [{ pattern: '^([0-9][0-9]*)+(.[0-9]{1,2})?$', message: '请输入数字' }]}]"
              />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否启用">
              <a-radio-group v-decorator="['status']">
                <a-radio :value="0">启用</a-radio>
                <a-radio :value="1">不启用</a-radio>
              </a-radio-group>
            </a-form-item>

            <a-form-item>
              <a-button
                style="margin-left:200px"
                type="primary"
                :loading="confirmLoading"
                @click="updateData"
              >更新指标设置</a-button>
            </a-form-item>
          </a-form>
        </a-col>
      </a-row>
    </div>
  </a-card>
</template>

<script>
import pick from 'lodash.pick'
import { baseMixin } from '@/store/app-mixin'

export default {
  name: 'tagerSetting',
  components: {},
  data() {
    return {
      record: {},
      confirmLoading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 }
      },
      form: this.$form.createForm(this),
      validatorRules: {
        phone: {
          rules: [
            {
              pattern: /^[1][3,4,5,7,8][0-9]{9}$/,
              message: '请输入正确的手机号码!'
            }
          ]
        }
      },
      url: '/pipe-network/water_company_indicators/list',
      addUrl: '/pipe-network/water_company_indicators'
    }
  },
  methods: {
    getDataList() {
      this.$http.get(this.url).then(res => {
        console.log('res',res);
        this.record =res.data[0]
              this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.record, 'finishingRate', 'lastLeakageRate', 'leakageRate', 'pipeLeght', 'pipeLeghtYear','recoveryRate','userSum', 'seeRate', 'userSumYear', 'valveSum', 'valveSumYear', 'waterDelivery', 'waterPower', 'waterSell', 'status'))
      })
      })
    },
    //更新数据
    updateData() {
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          console.log('this.record',this.record);
          console.log('values',values);
          let params = Object.assign(values)
          console.log('params',params);
          this.$http
            .post(this.addUrl, params)
            .then(res => {
              console.log('res',res);
              if (res.code == 0) {
                this.$message.success(res.message)
                this.getDataList()
              } else {
                this.$message.warning(res.message)
              }
            })
            .finally(() => {
              this.confirmLoading = false
              console.log('失败');
            })
        }
      })
    }
  },
  created() {
    this.getDataList()
  }
}
</script>

<style lang="less" scoped>
.avatar-upload-wrapper {
  height: 200px;
  width: 100%;
}

.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>


